import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { languages } from '../../constants/language';
import SelectField from '../global/fields/SelectField';

const options = [];

languages.sort(function (a, b) {
  return a.name.localeCompare(b.name);
});

for (let index = 0; index < languages.length; index++) {
  const language = languages[index];
  options.push({
    value: language.id,
    displayName: language.name,
  });
}

function UpdatePreferredLanguage({ fk, hide, value, updateFieldData }) {
  const [closeModal, updateCloseModal] = useState(true);

  return (
    <div className="modal-content update_preferred_language">
      <div className="modal-header bg-white">
        <h5 className="modal-title">Preferred language</h5>
      </div>
      <div className="modal-body">
        <SelectField
          placeholder={'Preferred Language'}
          options={options}
          key={fk}
          fk={fk}
          value={value}
          updateFieldData={(fk, values, error) => {
            const language = options.filter((item) => item.value === values);
            const displayName = language.length ? language[0].displayName : '';

            updateFieldData(fk, values, error, displayName);
            if (!closeModal) {
              hide();
            }

            if (closeModal) updateCloseModal(false);
          }}
        />
      </div>
      <div className="modal-footer mt-3">
        <button
          type="button"
          disabled={false}
          className={`button update_preferred_language__button`}
          onClick={hide}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

UpdatePreferredLanguage.propTypes = {
  hide: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  updateValue: PropTypes.func.isRequired,
};

export default UpdatePreferredLanguage;
